<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  @if (props?.label) {
    <label>
      <span>{{ props.label }}</span>
    </label>
  }

  <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
</div>

@if (props.options$.asObservable() | async; as options) {
  @for (option of options; track option) {
    <p>{{ getValue(option, props.label_key) }}</p>
  }
}
